import EstimatedShipDate from "@iewcasia/MobiusOverrides/Icons/EstimatedShipDate";
import ProductPartNumbers, { ProductPartNumbersStyles } from "@iewcasia/Overrides/Components/ProductPartNumbers";
import ProductPrice, { ProductPriceStyles } from "@iewcasia/Overrides/Components/ProductPrice";
import CartLineNotes, { CartLineNotesStyles } from "@iewcasia/Overrides/Widgets/Cart/CartLineNotes";
import setCustomShippingDetails from "@iewcasia/Store/Handlers/CheckoutReviewAndSubmit/CustomSetShippingDetails";
import useCustomQuoteRequired from "@iewcasia/Store/Handlers/Utilities/useCustomQuoteRequired";
import { CustomState } from "@iewcasia/Store/Reducers";
import { formatDateToMonthDay } from "@iewcasia/Utilities/Utilities";
import useOverlayCartLineBadge, {
    CartLineBadgesProps,
    CartLineCardBadgedStyles,
    useWidgetCartLineBadges,
} from "@iewcasia/Widgets/VerndaleBox/CartLineBadges";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import addDays from "@insite/client-framework/Common/Utilities/addDays";
import {
    convertDateOnlyStringToDate,
    convertDateToDateOnlyString,
} from "@insite/client-framework/Common/Utilities/DateUtilities";
import { HasCartLineContext, withCartLine } from "@insite/client-framework/Components/CartLineContext";
import { Cart } from "@insite/client-framework/Services/CartService";
																			   
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import updateCartLine from "@insite/client-framework/Store/Pages/Cart/Handlers/UpdateCartLine";
import translate from "@insite/client-framework/Translate";
import { PromotionModel } from "@insite/client-framework/Types/ApiModels";
import ProductAvailability, { ProductAvailabilityStyles } from "@insite/content-library/Components/ProductAvailability";
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import ProductDescription, { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import ProductImage, { ProductImageStyles } from "@insite/content-library/Components/ProductImage";
import ProductImageBadges from "@insite/content-library/Components/ProductImageBadges";
import ProductTextBadges from "@insite/content-library/Components/ProductTextBadges";
import SmallHeadingAndText, { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
																										
import CartLineQuantity, { CartLineQuantityStyles } from "@insite/content-library/Widgets/Cart/CartLineQuantity";
import Badge from "@insite/mobius/Badge";
import DatePicker, { DatePickerPresentationProps, DatePickerState } from "@insite/mobius/DatePicker";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Calendar from "@insite/mobius/Icons/Calendar";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

// Verndale Customization - extend CartLineBadgesProps
interface OwnProps extends CartLineBadgesProps {
    cart: Cart;
    promotions?: PromotionModel[];
    showSavingsAmount: boolean;
    showSavingsPercent: boolean;
    editable: boolean;
    showInvalidPriceMessage?: boolean;
    extendedStyles?: CartLineCardExpandedStyles;
    // Verndale Customization
    showPrice?: boolean;
}

const mapStateToProps = (state: CustomState, ownProps: OwnProps) => {
																	  
    const settingsCollection = getSettingsCollection(state);
										   
																								
   

    return {
        enableVat: getSettingsCollection(state).productSettings.enableVat,
        vatPriceDisplay: getSettingsCollection(state).productSettings.vatPriceDisplay,
        showPricing: state.context.showPricing,
        isCheckoutReviewAndSubmitPage: getCurrentPage(state).type === "CheckoutReviewAndSubmitPage",
        // VerndaleCustomization
        isOrderConfirmationPage: getCurrentPage(state).type === "OrderConfirmationPage",
        requestedDeliveryDate: state.pages.checkoutReviewAndSubmit.requestedDeliveryDate,
        settingsCollection,
        onCalendar: state.customReviewAndSubmit.onCalendar,
        estimateShipDateOrderChanged: state.customReviewAndSubmit.estimateShipDateOrderChanged,
        customCartLines: state.customReviewAndSubmit.cartLines,
        cartEstimateShipDate: state.customReviewAndSubmit.cartEstimateShipDate,
        // End VerndaleCustomization
    };
};

const mapDispatchToProps = {
    updateCartLine,
    setCustomShippingDetails,
};

type Props = OwnProps &
    HasCartLineContext &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps>;

export interface CartLineCardExpandedStyles extends CartLineCardBadgedStyles {
    cartLineNotes?: CartLineNotesStyles;
    price?: ProductPriceStyles;
    quantity?: CartLineQuantityStyles;
    container?: GridContainerProps;
    productImageGridItem?: GridItemProps;
    productImage?: ProductImageStyles;
    orderLineInfoGridItem?: GridItemProps;
    orderLineInfoContainer?: GridContainerProps;
    productDescriptionAndPartNumbersGridItem?: GridItemProps;
    productDescriptionAndPartNumbersContainer?: GridContainerProps;
    productBrand?: ProductBrandStyles;
    productBrandAndDescriptionGridItem?: GridItemProps;
    productDescription?: ProductDescriptionStyles;
    configurationGridItem?: GridItemProps;
    configurationOptionText?: TypographyProps;
    productPartNumbersGridItem?: GridItemProps;
    productPartNumbers?: ProductPartNumbersStyles;
    orderLineNotesGridItem?: GridItemProps;
    notesHeadingAndText?: SmallHeadingAndTextStyles;
    costCodeGridItem?: GridItemProps;
    costCodeValueText?: TypographyPresentationProps;
    costCodeLabelText?: TypographyPresentationProps;
    productPriceAndQuantityGridItem?: GridItemProps;
    productPriceAndQuantityContainer?: GridContainerProps;
    priceGridItem?: GridItemProps;
    priceHeadingAndText?: SmallHeadingAndTextStyles;
    promotionNameText?: TypographyProps;
    quantityGridItem?: GridItemProps;
    qtyHeadingAndText?: SmallHeadingAndTextStyles;
    extendedUnitNetPriceGridItem?: GridItemProps;
    extendedUnitNetPrice?: SmallHeadingAndTextStyles;
    subtotalWithoutVatText?: SmallHeadingAndTextStyles;
    vatAmount?: SmallHeadingAndTextStyles;
    cartLineErrorMessageGridItem?: GridItemProps;
    cartLineErrorMessageText?: TypographyProps;
    // Verndale Customization
    // File: src/FrontEnd/modules/blueprints/iewc/src/WidgetExtensions/Components/CartLineCardExpandedExtension.ts
    estimatedShipDateItem?: GridItemProps;
    estimatedShipDateLabel?: TypographyProps;
    estimatedShipDateValue?: TypographyProps;
    estimadedShipIcon?: IconPresentationProps;
    changeShipDate?: TypographyProps;
    changeShipDateIcon?: IconPresentationProps;
    deliveryDatePicker?: DatePickerPresentationProps;
    customMoqGridItem?: GridItemProps;
    customMoqItem?: InjectableCss;
    productAvailability?: ProductAvailabilityStyles;
    putUpPriceText?: SmallHeadingAndTextStyles;
    // End Verndale Customization
}

export const cartLineCardExpandedStyles: CartLineCardExpandedStyles = {
    container: {
        gap: 20,
        css: css`
            border-bottom: 1px solid ${getColor("common.border")};
            padding: 1rem 0;
        `,
    },
    productImageGridItem: {
        width: 2,
        printWidth: 1,
        css: css`
            @media print {
                max-height: 83px;
                max-width: 83px;
                padding: 0;
            }
        `,
    },
    orderLineInfoGridItem: {
        width: 10,
        printWidth: 11,
    },
    orderLineInfoContainer: {
        gap: 15,
    },
    productDescriptionAndPartNumbersGridItem: {
        width: [12, 12, 5, 5, 5],
        printWidth: 6,
    },
    productDescriptionAndPartNumbersContainer: {
        gap: 15,
    },
    productBrand: {
        nameText: {
            color: "text.main",
        },
    },
    productBrandAndDescriptionGridItem: {
        css: css`
            flex-direction: column;
        `,
        width: 12,
    },
    configurationGridItem: {
        width: 12,
        css: css`
            flex-direction: column;
        `,
    },
    productPartNumbersGridItem: {
        width: 12,
    },
    orderLineNotesGridItem: {
        width: 12,
    },
    costCodeGridItem: { width: 12 },
    costCodeLabelText: {
        weight: "bold",
        css: css`
            margin-right: 10px;
        `,
    },
    productPriceAndQuantityGridItem: {
        width: [12, 12, 7, 7, 7],
        printWidth: 6,
    },
    productPriceAndQuantityContainer: {
        gap: 15,
    },
    priceGridItem: {
        width: [12, 12, 5, 5, 5],
        printWidth: 5,
        css: css`
            flex-direction: column;
        `,
    },
    quantityGridItem: {
        width: [12, 12, 3, 3, 3],
    },
    extendedUnitNetPriceGridItem: {
        width: [12, 12, 4, 4, 4],
        css: css`
            flex-direction: column;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            flex-flow: wrap;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    extendedUnitNetPrice: {
        text: {
            weight: 700,
        },
    },
    subtotalWithoutVatText: {
        wrapper: {
            css: css`
                margin-bottom: 6px;
                width: 100%;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                width: 50%;
                            `,
                        ],
                        "max",
                    )}
            `,
        },
    },
    vatAmount: {
        wrapper: {
            css: css`
                margin-bottom: 6px;
                width: 100%;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                width: 50%;
                            `,
                        ],
                        "max",
                    )}
            `,
        },
    },
    cartLineErrorMessageGridItem: {
        width: 12,
    },
    cartLineErrorMessageText: {
        color: "danger",
    },
};

const CartLineCardExpanded = ({
    cart,
    cartLine,
    showSavingsAmount,
    showSavingsPercent,
    promotions,
    editable,
    enableVat,
    vatPriceDisplay,
    showInvalidPriceMessage,
    showPricing,
    isCheckoutReviewAndSubmitPage,
    extendedStyles,
    // Verndale customization
    showPrice = true,
    isOrderConfirmationPage,
    onCalendar,
    showImageBadges,
    maximumNumberOfImageBadges,
    showTextBadges,
    maximumNumberOfTextBadges,
    setCustomShippingDetails,
    customCartLines,
    cartEstimateShipDate,
}: Props) => {
    const [styles] = React.useState(() => mergeToNew(cartLineCardExpandedStyles, extendedStyles));

    // Verndale Customization
    const [estimatedShipDateValue, setEstimatedShipDateValue] = useState<Date | null>(null);
    const [estimatedShipBackOrderDateValue, setEstimatedShipBackOrderDateValue] = useState<string | null>(null);
    const [estimatedShippingValidDates, setEstimatedShippingValidDates] = useState<string[]>([]);
    const [minDate, setMinDate] = useState<Date | null>(null);
    const [showChangeDatePicker, setShowChangeDatePicker] = useState(false);

    useEffect(() => {
        const isBackOrder = cartLine.properties["isBackOrder"] === "true";
        if (
            isCheckoutReviewAndSubmitPage &&
            onCalendar &&
            minDate !== null &&
            estimatedShipDateValue !== null &&
            !isBackOrder
        ) {
            setShowChangeDatePicker(true);
        } else {
            setShowChangeDatePicker(false);
        }
    }, [onCalendar, minDate, estimatedShipDateValue, cartLine.properties]);

    useEffect(() => {
        if (isOrderConfirmationPage) {
            if (cartLine.properties["isBackOrder"] && cartLine.properties["isBackOrder"] === "true") {
                if (onCalendar) {
                    setEstimatedShipBackOrderDateValue(`${cartLine.properties["deliveryLeadTimeWeeks"]} Weeks`);
                    setEstimatedShipDateValue(
                        convertDateOnlyStringToDate(cartLine.properties["estimatedShippingDate"]) as Date,
                    );
                } else {
                    setEstimatedShipBackOrderDateValue(`${cartLine.properties["deliveryLeadTimeWeeks"]} Weeks`);
                    setEstimatedShipDateValue(cart.orderDate as Date);
                }
            } else {
                setEstimatedShipDateValue(
                    convertDateOnlyStringToDate(cartLine.properties["calendarShippingDate"]) as Date,
                );
            }

            return;
        }

        const customCartline = customCartLines.find(customCartLine => customCartLine.id === cartLine.id);

        if (!customCartline) {
            return;
        }

        if (cartLine.properties["isBackOrder"] && cartLine.properties["isBackOrder"] === "true") {
            if (onCalendar) {
                setEstimatedShipBackOrderDateValue(`${cartLine.properties["deliveryLeadTimeWeeks"]} Weeks`);
                setEstimatedShipDateValue(
                    convertDateOnlyStringToDate(cartLine.properties["estimatedShippingDate"]) as Date,
                );
            } else {
                setEstimatedShipBackOrderDateValue(`${cartLine.properties["deliveryLeadTimeWeeks"]} Weeks`);
                setEstimatedShipDateValue(cart.orderDate as Date);
            }
        } else {
            setEstimatedShipDateValue(convertDateOnlyStringToDate(customCartline.estimateShipDate) as Date);
        }
    }, [cartEstimateShipDate, customCartLines]);

    useEffect(() => {
        const {
            properties: { estimatedShippingValidDates },
        } = cart;

        if (estimatedShippingValidDates && estimatedShippingValidDates.length > 0) {
            const validDates = estimatedShippingValidDates.split(",");
            setEstimatedShippingValidDates(validDates);

            if (validDates.length === 1) {
                setMinDate(convertDateOnlyStringToDate(validDates[0]) as Date);
            } else {
                // we find the minimum date
                const minDate = validDates.reduce((prevDate: string, currentDate: string) => {
                    const prev = convertDateOnlyStringToDate(prevDate);
                    const current = convertDateOnlyStringToDate(currentDate);

                    const result = prev && current && prev < current ? prev : current;
                    return convertDateToDateOnlyString(result);
                }, "");
                setMinDate(convertDateOnlyStringToDate(minDate) as Date);
            }
        } else {
            setMinDate(addDays(new Date(), 1));
        }
    }, [cart]);

    const handleRequestDeliveryDateChanged = ({ selectedDay }: DatePickerState) => {
        if (selectedDay === null || selectedDay === estimatedShipDateValue) {
            return;
        }

        // we modify the cart line properties and then we update the cart line
        const cartLines = customCartLines.map(customCartLine => {
            if (customCartLine.id === cartLine.id) {
                return {
                    id: cartLine.id,
                    estimateShipDate: convertDateToDateOnlyString(selectedDay as Date),
                };
            }

            return customCartLine;
        });

        setCustomShippingDetails({
            onCalendar: true,
            estimateShipDateOrderChanged: true,
            cartLines,
        });
        setEstimatedShipDateValue(selectedDay as Date);
    };

    const { showOverlayBadge, overlayBadge, overlayBadgeWrapperStyles } = useOverlayCartLineBadge({
        cartLine,
        showTextBadge: showTextBadges,
        showImageBadge: showImageBadges,
        styles,
    });

    const { imageBadges, textBadges } = useWidgetCartLineBadges({ cartLine, showTextBadges, showImageBadges });

    /* Verndale Custom Feature - Flags to verify if information should show or not based on CMI or Manufacturer */
    const isCmiProduct = (cartLine.properties["isc_isCmiProduct"] ?? "").toLowerCase() === "true";
    const shouldShowBrand =
        cartLine.brand &&
        !isCmiProduct &&
        (cartLine.properties["manufacturerNameValue"] ?? "").toLowerCase() !== "approved manufacturer";

    // End Verndale Customization

    // Verndale Customization

    const hasSpools = !!cartLine.properties["spoolSelected"];
    const isQuoteRequired = useCustomQuoteRequired(cartLine);

    // End Verndale Customization

    return (
        <GridContainer
            {...styles.container}
            data-test-selector={`cartline_expanded_${cartLine.productId}_${cartLine.unitOfMeasure}`}
        >
            <GridItem {...styles.productImageGridItem}>
                {!showOverlayBadge && <ProductImage product={cartLine} extendedStyles={styles.productImage} />}
                {showOverlayBadge && overlayBadge && (
                    <StyledWrapper {...styles.badgeAreaWrapper} data-test-selector="productCompareBadge">
                        <ProductImage extendedStyles={styles.productImage} product={cartLine} />
                        <StyledWrapper {...overlayBadgeWrapperStyles}>
                            <Badge
                                type={overlayBadge.badgeType}
                                value={
                                    overlayBadge.badgeType === "Image"
                                        ? overlayBadge.largeImageBadgePath
                                        : overlayBadge.displayText
                                }
                                badgeTextColor={overlayBadge.textColorHexCode}
                                badgeBackgroundColor={overlayBadge.badgeColorHexCode}
                                badgeTextRounding={overlayBadge.badgeStyle === "Round" ? 20 : 0}
                                imageAltText={overlayBadge.imageAltText ? overlayBadge.imageAltText : overlayBadge.name}
                                textBadgeCss={styles.badgeText}
                                imageBadgeProps={styles.badgeImageProps}
                            />
                        </StyledWrapper>
                    </StyledWrapper>
                )}
            </GridItem>
            <GridItem {...styles.orderLineInfoGridItem}>
                <GridContainer {...styles.orderLineInfoContainer}>
                    <GridItem {...styles.productDescriptionAndPartNumbersGridItem}>
                        <GridContainer {...styles.productDescriptionAndPartNumbersContainer}>
                            <GridItem {...styles.productBrandAndDescriptionGridItem}>
                                {shouldShowBrand && (
                                    <ProductBrand brand={cartLine.brand!} extendedStyles={styles.productBrand} />
                                )}
                                <ProductDescription product={cartLine} extendedStyles={styles.productDescription} />
                            </GridItem>
                            {!cartLine.isFixedConfiguration && cartLine.sectionOptions!.length > 0 && (
                                <GridItem {...styles.configurationGridItem}>
                                    {cartLine.sectionOptions!.map(option => (
                                        <Typography {...styles.configurationOptionText} key={option.sectionOptionId}>
                                            {`${option.sectionName}:${option.optionName}`}
                                        </Typography>
                                    ))}
                                </GridItem>
                            )}
                            <GridItem {...styles.productPartNumbersGridItem}>
                                <ProductPartNumbers
                                    productNumber={cartLine.erpNumber}
                                    customerProductNumber={cartLine.customerName}
                                    manufacturerItem={cartLine.manufacturerItem}
                                    extendedStyles={styles.productPartNumbers}
                                    // Verndale Customization
                                    showManufacturerItem={!isCmiProduct}
                                    cmiCustomerNumber={cartLine.properties["isc_cmiCustomer"] ?? ""}
                                    modelNumber={cartLine.properties["product_modelNumber"] ?? ""}
                                    cmiIewcMaterial={cartLine.properties["isc_cmiIewcMaterial"] ?? ""}
                                    manufacturerName={cartLine.properties["manufacturerNameValue"] ?? ""}
                                    // END Verndale Customization
                                />
                            </GridItem>
                            {/* Verndale Customization Start - Show custom availability */}
                            <ProductAvailability
                                productId={cartLine.productId!}
                                availability={cartLine.availability!}
                                unitOfMeasure={cartLine.unitOfMeasure}
                                trackInventory={cartLine.trackInventory}
                                failedToLoadInventory={cart.failedToGetRealTimeInventory}
                                extendedStyles={styles.productAvailability}
                            />
                            {/* Verndale Customization End - Show custom availability */}
                            {showTextBadges && textBadges && textBadges.length > 0 && (
                                <GridItem {...styles.textBadgeGridItem}>
                                    <ProductTextBadges
                                        badgeList={textBadges}
                                        maxBadges={maximumNumberOfTextBadges ?? 4}
                                        extendedStyles={styles.textBadgeStyles}
                                    />
                                </GridItem>
                            )}
                            {showImageBadges && imageBadges && imageBadges.length > 0 && (
                                <GridItem {...styles.imageBadgeGridItem}>
                                    <ProductImageBadges
                                        badgeList={imageBadges}
                                        maxBadges={maximumNumberOfImageBadges ?? 4}
                                        extendedStyles={styles.imageBadgeStyles}
                                    />
                                </GridItem>
                            )}

                            {cartLine.isRestricted && (
                                <GridItem {...styles.cartLineErrorMessageGridItem}>
                                    <Typography
                                        {...styles.cartLineErrorMessageText}
                                        data-test-selector="cartline_restrictedMessage"
                                    >
                                        {translate("Restricted product")}
                                    </Typography>
                                </GridItem>
                            )}
                            {!cartLine.isActive && (
                                <GridItem {...styles.cartLineErrorMessageGridItem}>
                                    <Typography {...styles.cartLineErrorMessageText}>
                                        {translate("Inactive Product")}
                                    </Typography>
                                </GridItem>
                            )}
                        </GridContainer>
                    </GridItem>
                    <GridItem {...styles.productPriceAndQuantityGridItem}>
                        <GridContainer {...styles.productPriceAndQuantityContainer}>
                            <GridItem {...styles.priceGridItem}>
                                {/* Verndale Customization */}
                                {showPrice && (
                                    <ProductPrice
                                        product={cartLine}
                                        showSavings={true}
                                        showSavingsAmount={showSavingsAmount}
                                        showSavingsPercent={showSavingsPercent}
                                        showInvalidPriceMessage={showInvalidPriceMessage}
                                        extendedStyles={styles.price}
                                    />
                                )}
                                {/* End Verndale Customization */}
                                {promotions?.map(promotion => (
                                    <Typography
                                        {...styles.promotionNameText}
                                        key={promotion.id}
                                        data-test-selector="orderLineCardExpandedPromotionName"
                                    >
                                        {promotion.name}
                                    </Typography>
                                ))}
                            </GridItem>
                            {/* // Verndale Customization */}
                            {hasSpools && !isQuoteRequired && (
                                <GridItem {...styles.quantityGridItem}>
                                    <SmallHeadingAndText
                                        heading={`${translate("Put-Up")}`}
                                        text={`${cartLine.properties["spoolSelected"]} x ${cartLine.properties["spoolLength"]}  ${cartLine.unitOfMeasureDisplay}`}
                                        extendedStyles={styles.putUpPriceText}
                                    />
                                </GridItem>
                            )}
                            {/* End Verndale Customization */}

                            <GridItem {...styles.quantityGridItem} data-test-selector="orderConformation_Quantity">
                                <CartLineQuantity cart={cart} editable={editable} extendedStyles={styles.quantity} />
                            </GridItem>
                            <GridItem {...styles.extendedUnitNetPriceGridItem}>
                                {cartLine.pricing && (showPricing || isCheckoutReviewAndSubmitPage) && (
                                    <>
                                        {enableVat && vatPriceDisplay === "DisplayWithAndWithoutVat" && (
                                            <>
                                                <SmallHeadingAndText
                                                    heading={`${translate("Line Subtotal")} (${translate("Ex. VAT")})`}
                                                    text={cartLine.pricing.extendedUnitNetPriceDisplay}
                                                    extendedStyles={styles.subtotalWithoutVatText}
                                                />
                                                <SmallHeadingAndText
                                                    heading={`${translate("Total VAT")} (${cartLine.pricing.vatRate}%)`}
                                                    text={cartLine.pricing.vatAmountDisplay}
                                                    extendedStyles={styles.vatAmount}
                                                />
                                            </>
                                        )}
                                        <SmallHeadingAndText
                                            heading={
                                                !enableVat
                                                    ? translate("Line Subtotal")
                                                    : vatPriceDisplay !== "DisplayWithoutVat"
                                                      ? `${translate("Line Subtotal")} (${translate("Inc. VAT")})`
                                                      : `${translate("Line Subtotal")} (${translate("Ex. VAT")})`
                                            }
                                            text={
                                                enableVat && vatPriceDisplay !== "DisplayWithoutVat"
                                                    ? cartLine.pricing.extendedUnitRegularPriceWithVatDisplay
                                                    : cartLine.pricing.extendedUnitNetPriceDisplay
                                            }
                                            extendedStyles={styles.extendedUnitNetPrice}
                                        />
                                    </>
                                )}
                            </GridItem>
                        </GridContainer>
                    </GridItem>

                    {/* Verndale Customization */}
                    {(isCheckoutReviewAndSubmitPage || isOrderConfirmationPage) &&
                        (estimatedShipDateValue || estimatedShipBackOrderDateValue) && (
                            <GridItem {...styles.estimatedShipDateItem}>
                                <Typography {...styles.estimatedShipDateLabel}>
                                    <Icon src={EstimatedShipDate} {...styles.estimadedShipIcon} />
                                    {translate("Estimated Ship Date")}
                                    <span {...styles.estimatedShipDateValue}>
                                        {cartLine.properties["isBackOrder"] === "true"
                                            ? typeof estimatedShipBackOrderDateValue === "undefined"
                                                ? "0 Weeks"
                                                : estimatedShipBackOrderDateValue
                                            : formatDateToMonthDay(
                                                  convertDateToDateOnlyString(estimatedShipDateValue as Date),
                                              )}
                                    </span>
                                </Typography>

                                {showChangeDatePicker && (
                                    <DatePicker
                                        {...styles.deliveryDatePicker}
                                        label={
                                            <Typography {...styles.changeShipDate}>
                                                <Icon src={Calendar} {...styles.changeShipDateIcon} size={12} />
                                                {translate("Change Ship Date")}
                                            </Typography>
                                        }
                                        selectedDay={estimatedShipDateValue as Date}
                                        onDayChange={handleRequestDeliveryDateChanged}
                                        placeholders={{}}
                                        dateTimePickerProps={{
                                            minDate: minDate ?? undefined,
                                            monthAriaLabel: translate("Request delivery date month"),
                                            dayAriaLabel: translate("Request delivery date day"),
                                            yearAriaLabel: translate("Request delivery date year"),
                                            calendarProps: {
                                                tileDisabled: (tile: { date: Date | undefined }) => {
                                                    if (
                                                        !estimatedShippingValidDates ||
                                                        estimatedShippingValidDates.length === 0
                                                    ) {
                                                        return false;
                                                    }

                                                    const isValid = estimatedShippingValidDates.includes(
                                                        convertDateToDateOnlyString(tile.date),
                                                    );

                                                    return !isValid;
                                                },
                                            },

                                            ...styles.deliveryDatePicker?.dateTimePickerProps,
                                        }}
                                    />
                                )}
                            </GridItem>
                        )}
                    {/* End Verndale Customization */}

                    {cartLine.notes && (
                        <GridItem {...styles.orderLineNotesGridItem}>
                            <CartLineNotes
                                cart={cart}
                                editable={editable}
                                label={translate("Line Notes")}
                                extendedStyles={styles.cartLineNotes}
                            />
                        </GridItem>
                    )}
				 {cart.showCostCode && cartLine.costCode && (
                        <GridItem {...styles.costCodeGridItem} data-test-selector="orderConformation_CostCode">
                            <Typography {...styles.costCodeValueText} as="p">
                                <Typography {...styles.costCodeLabelText}>{cart.costCodeLabel}:</Typography>
                                {cartLine.costCode}
                            </Typography>
                        </GridItem>
                    )}
                </GridContainer>
            </GridItem>
        </GridContainer>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withCartLine(CartLineCardExpanded));
